export const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export const capitalize = <T extends string>(str: T): Capitalize<T> =>
  (str.charAt(0).toUpperCase() + str.slice(1)) as Capitalize<T>

/** trims the string and returns undefined if it is empty */
export const compactString = (s?: string) => {
  if (s == null) return
  const trimmed = s.trim()
  return trimmed.length == 0 ? undefined : trimmed
}

export const doubleQuote = (s: string | undefined) => {
  const escaped = s?.replace(new RegExp('"', 'g'), '\\"')
  return s ? `"${escaped}"` : ''
}

/** very simple hash of the given string to a hashes the given string */
export const hashStringToNumber = (str: string, max: number) =>
  Math.abs(str.split('').reduce((acc, char) => (acc << 5) - acc + char.charCodeAt(0), 0)) % max

export const hashString = async (input: string, opts: {salt?: string; length?: number} = {}) => {
  const {salt = '', length = 12} = opts
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(salt + input))
  const b64url = btoa(String.fromCharCode(...new Uint8Array(buf)))
  return length != null ? b64url.slice(0, length) : b64url
}

export const slugify = (name: string) =>
  name
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^a-z0-9-]/g, '')
